const marketHistoryInitialState = {
  loaded: false,
  data: Object.create(null),
}

export default marketHistoryInitialState
